import { Injectable, Injector } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';
import { CORE_ACTIONS } from "@ispm/core/constants/core-actions.constant";
import { Store } from '@ngrx/store';
import {IgenomicsState} from "@ispm/core/interfaces/genomics-state.interface";
import {CLINICALDASHBOARD_ACTIONS} from "@ispm-client/modules/clinical-dashboard/store/actions/index";

@Injectable()
export class ClinicalDashboardEffects {
  constructor(private actions$: Actions, private store$: Store<IgenomicsState>) { }

  @Effect({ dispatch: false})
  clearingClinicalDashboard  = this.actions$.pipe(
    ofType(CORE_ACTIONS.CLEAR_ALL_CACHED_ITEMS),
    tap(() => {
      this.store$.dispatch({
        type: CLINICALDASHBOARD_ACTIONS.CLEAR_CLINICAL_DASHBOARD,
        payload: {}
      });

      this.store$.dispatch({
        type: CLINICALDASHBOARD_ACTIONS.CHANGE_SELECTED_DASHBOARD,
        payload: null
      });

    }));

}
